export default __webpack_public_path__ + "static/media/BT.ef7444a3.svg";